import { render, staticRenderFns } from "./digital_list_cell.vue?vue&type=template&id=90868fde"
import script from "./digital_list_cell.vue?vue&type=script&lang=js"
export * from "./digital_list_cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports